/* eslint-disable */
export default {
  dialPlaceholder: 'Name/Nr. eingeben',
} as const;

// @key: @#@"dialPlaceholder"@#@ @source: @#@"Enter name or number"@#@
